import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import "moment-timezone";
import {SlideDown} from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'

import {styles} from "assets/jss/user-details-box.jsx";

import connection from "../connection";
import general from "../general";
import MomentFromNow from "./MomentFromNow";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "./CustomButtons/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faCheckCircle, faCircle, faExclamationTriangle, faEye, faHourglassHalf, faSpinner, faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import AcoesUtilizador from "../other/AcoesUtilizador";
import EstadoParticipacaoModulo from "./EstadoParticipacaoModulo";

const ETIQUETA_FORMULARIO_MAP = {
  "parecer_pfe_formador": "Parecer PFE Formador",
  "pfe_formador": "PFE Formador",
  "parecer_pfe_diretor_formacao": "Parecer PFE Diretor de Formação",
  "pfe_diretor_formacao": "PFE Diretor de Formação"
};

const ESTADO_FORMULARIO_MAP = {
  "POR_PREENCHER": {label: "Por preencher", icon: faCircle, color: "#aab3c4"},
  "EM_PREENCHIMENTO": {label: "Em preenchimento", icon: faSpinner, color: "#1babbf"},
  "SUBMETIDO": {label: "Submetido", icon: faHourglassHalf, color: "#6a93a2"},
  "REABERTO": {label: "Reaberto", icon: faExclamationTriangle, color: "#fd9729"},
  "REJEITADO": {label: "Rejeitado", icon: faTimesCircle, color: "#bb0000"},
  "VALIDADO": {label: "Validado", icon: faCheckCircle, color: "#16924a"}
};

class UserDetailsBox extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      user: null
    };

    // Se o UserDetailsBox receber o progresso_candidato para mostrar no separador Tutorandos, não é necessário fazer o pedido ao servidor porque os dados já são enviados na props
    if (!this.props.progresso_candidato)
      connection.get(this.props.dataUrl).then((data) => {
        this.setState({user: data});
      });
  }

  render() {
    const {classes} = this.props;

    if (this.props.progresso_candidato)
      return <SlideDown className={'my-dropdown-slidedown'}>
        <div className={classes.wrapper}>
          {this.props.percursos_em_progresso.length > 0 && <React.Fragment>
            <h4 style={{marginLeft: "10px"}}>Percurso(s) em progresso:</h4>
            {this.props.percursos_em_progresso.map((percurso) => {
              return <table className={classes.table}>
                <tr>
                  <td></td>
                  <td>
                    <table>
                      <tr>
                        <th style={{minWidth: 255}}>Percurso</th>
                        <th>Fases em Progresso</th>
                        <th>Data de registo</th>
                      </tr>
                      <tr>
                        <td style={{minWidth: 255}}>{percurso.codigo}</td>
                        <td style={{minWidth: 360}}>{percurso.fases_em_progresso.length >= 0 ? percurso.fases_em_progresso.map(estado => <span><FontAwesomeIcon icon={faCheck} color={"#1cacbf"}/> {estado}<br/></span>) : null}</td>
                        <td style={{minWidth: 100}}>{general.Renderers.dateRenderer(percurso.data_registo, {full: true})}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            })}
          </React.Fragment>}
          {this.props.cursos_em_progresso.length > 0 && <React.Fragment>
            <h4 style={{marginLeft: "10px"}}>Curso(s) em progresso:</h4>
            {this.props.cursos_em_progresso.map((curso) => {
              return <table className={classes.table}>
                <tr>
                  <td></td>
                  <td>
                    <table>
                      <tr>
                        <th style={{minWidth: 255}}>Curso</th>
                        <th>Percurso</th>
                        <th>Data de registo</th>
                      </tr>
                      <tr>
                        <td style={{minWidth: 255}}>{curso.codigo}</td>
                        <td style={{minWidth: 360}}>{curso.codigo_percurso ? curso.codigo_percurso : "Curso isolado"}</td>
                        <td style={{minWidth: 100}}>{general.Renderers.dateRenderer(curso.data_registo, {full: true})}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            })}
          </React.Fragment>}
        </div>
      </SlideDown>;

    return <SlideDown className={'my-dropdown-slidedown'}>
      {this.state.user && <div className={classes.wrapper}>
        {this.state.user && <React.Fragment>
          <table className={classes.table}>
            {this.props.data_registo && <tr>
              <td>Data de registo</td>
              <td>{general.Renderers.dateRenderer(this.props.data_registo, {full: true})}</td>
            </tr>}
            {this.state.user.NIN && <tr>
              <td>NIN:</td>
              <td>{this.state.user.NIN}</td>
            </tr>}
            {this.state.user.agrupamento && <tr>
              <td>Agrupamento:</td>
              <td>{this.state.user.agrupamento}</td>
            </tr>}
            {this.state.user.nucleo && <tr>
              <td>Núcleo:</td>
              <td>{this.state.user.nucleo}</td>
            </tr>}
            {this.state.user.regiao && <tr>
              <td>Região:</td>
              <td>{this.state.user.regiao}</td>
            </tr>}
            {this.props.tipo_acontecimento !== 'percurso' && (this.props.preco || this.props.preco === 0) && <tr>
              <td>Valor do pagamento:</td>
              <td>{this.props.preco.toFixed(2).replace(".", ",") + "€"}</td>
            </tr>}
            {this.props.prioridade_detalhes && <React.Fragment>
              <tr>
                <td>Detalhes de seleção:</td>
                <td>
                  <table>
                    <tr>
                      <th>Razão</th>
                      <th>Pontos</th>
                    </tr>
                    {(() => {
                      try {
                        return Object.values(JSON.parse(this.props.prioridade_detalhes)).map((criterio) => {
                          if (!criterio.razao || criterio.razao.trim() === '')
                            return null;
                          return <tr>
                            <td>{criterio.razao}</td>
                            <td>{criterio.pontos}</td>
                          </tr>
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    })()}
                  </table>
                </td>
              </tr>
            </React.Fragment>}
            {this.props.tipo_acontecimento !== 'percurso' && (this.props.data_selecao || typeof this.props.prioridade_inscricao !== "undefined") && <tr>
              <td>Resultado da seleção:</td>
              <td>{this.props.data_selecao ? <span>Selecionado - {general.Renderers.dateRenderer(this.props.data_selecao, {full: true})}</span> : (this.props.apurado ? "Apurado" : "Não apurado")}</td>
            </tr>}
            {this.props.data_limite_pagamento && <tr>
              <td>Limite para pagamento</td>
              <td><MomentFromNow time={this.props.data_limite_pagamento}/> - {general.Renderers.dateRenderer(this.props.data_limite_pagamento, {full: true})}</td>
            </tr>}
            {this.props.tutor_nome && <tr>
              <td>Tutor atribuído:</td>
              <td>{this.props.tutor_nome} ({this.props.tutor_nin})</td>
            </tr>}
            {(typeof this.props.estado_participacao !== "undefined" && this.props.estado_participacao) && <React.Fragment>
              <tr>
                <td>Informações sobre progresso no curso:</td>
                <td>
                  {(() => {
                    try {
                      let info = JSON.parse(this.props.estado_participacao);
                      return <>
                        <table>
                          <tr>
                            <th style={{minWidth: 255}}>Módulo</th>
                            <th>Estado/Explicação</th>
                            <th>Última participação</th>
                          </tr>
                          {info.resultado_modulos.map((modulo) => {
                            return <tr>
                              <td><strong>{modulo.modulo}</strong><br/>
                                <small>{modulo.frequencia}</small>
                              </td>
                              <td><EstadoParticipacaoModulo estado={modulo} detailed/><br/>
                                <small>{modulo.resultado.extra}</small>
                              </td>
                              <td>{modulo.ultima_participacao ? <Tooltip
                                title={({"-1": "Reprovado", "0": "Avaliação pendente", "1": "Aprovado"})[modulo.ultima_participacao.resultado]}
                                placement="left"
                              ><span>{general.Renderers.dateRenderer(modulo.ultima_participacao.data, {hide_timezone: true})}</span></Tooltip> : "Nunca"}</td>
                            </tr>
                          })}
                        </table>

                        {info.estado_formularios && info.estado_formularios.length > 0 &&
                          <table>
                            <tr>
                              <th style={{minWidth: 200}}>Formulário</th>
                              <th>Estado</th>
                              <th style={{textAlign: "center"}}>Ver</th>
                            </tr>
                            {info.estado_formularios.map((formulario) => {
                              const estadoInfo = ESTADO_FORMULARIO_MAP[formulario.estado];
                              const estadoLabel = estadoInfo ? estadoInfo.label : formulario.estado.replace(/_/g, " ").toLowerCase();
                              return <tr key={formulario.configuracao.formulario_etiqueta}>
                                <td>{ETIQUETA_FORMULARIO_MAP[formulario.configuracao.formulario_etiqueta] || formulario.configuracao.formulario_etiqueta}</td>
                                <td style={{textAlign: "left"}}>
                                  {estadoInfo && <FontAwesomeIcon icon={estadoInfo.icon} style={{color: estadoInfo.color, marginRight: 5}}/>}
                                  {estadoLabel}
                                </td>
                                <td style={{textAlign: "center"}}>
                                  {formulario.id_submissao &&
                                    <a href={`/formulario/ver?submissao=${formulario.id_submissao}&utilizador=${this.state.user.id}`}>
                                      <FontAwesomeIcon icon={faEye} style={{color: "#00acc1"}}/>
                                    </a>
                                  }
                                </td>
                              </tr>;
                            })}
                          </table>
                        }

                        <table>
                          <tr>
                            <th>Resultado</th>
                            <td style={{textAlign: "left"}}>{info.resultado.designacao}{info.resultado.explicacao && <small><br/>{info.resultado.explicacao}</small>}{this.props.qualificacao_anulada_por_nome && <> por {this.props.qualificacao_anulada_por_nome} ({this.props.qualificacao_anulada_por_nin})</>}</td>
                          </tr>
                          {this.props.estado_participacao_codigo === 'ANUL' && <>
                            <tr>
                              <th>Justificação</th>
                              <td style={{textAlign: "left"}}>{this.props.justificacao_qualificacao_anulada}{info.resultado.explicacao && <small><br/>{info.resultado.explicacao}</small>}</td>
                            </tr>
                          </>}
                        </table>
                      </>;
                    } catch (e) {
                      console.log(e);
                    }
                  })()}
                </td>
              </tr>
            </React.Fragment>}

            {this.props.participantesCursosIntegrados && <React.Fragment>
              {this.props.participantesCursosIntegrados.map((curso) => {
                // Verificar se o utilizador está inscrito no curso integrado ao percurso
                let participante = curso.participantes.filter((participante) => participante.id === this.state.user.id);

                if (participante.length > 0)
                  return (<tr>
                    <td>Informações sobre progresso no curso:</td>
                    <td>
                      {(() => {
                        try {
                          let info = JSON.parse(participante[0].estado_participacao);
                          return [
                            <table>
                              <tr>
                                <th style={{minWidth: 255}}>Módulo</th>
                                <th>Estado/Explicação</th>
                                <th>Última participação</th>
                              </tr>
                              {info.resultado_modulos.map((modulo) => {
                                return <tr>
                                  <td><strong>{modulo.modulo}</strong><br/>
                                    <small>{modulo.frequencia}</small>
                                  </td>
                                  <td><EstadoParticipacaoModulo estado={modulo} detailed/><br/>
                                    <small>{modulo.resultado.extra}</small>
                                  </td>
                                  <td>{modulo.ultima_participacao ? <Tooltip
                                    title={({"-1": "Reprovado", "0": "Avaliação pendente", "1": "Aprovado"})[modulo.ultima_participacao.resultado]}
                                    placement="left"
                                  ><span>{general.Renderers.dateRenderer(modulo.ultima_participacao.data, {hide_timezone: true})}</span></Tooltip> : "Nunca"}</td>
                                </tr>
                              })}
                            </table>, <table>
                              <tr>
                                <th>Resultado</th>
                                <td style={{textAlign: "left"}}>{info.resultado.designacao}{info.resultado.explicacao && <small><br/>{info.resultado.explicacao}</small>}</td>
                              </tr>
                            </table>];
                        } catch (e) {
                          console.log(e);
                        }
                      })()}
                    </td>
                  </tr>)
              })}
            </React.Fragment>}

            {this.props.estados_utilizador_percurso && <>
              <tr>
                <td>Estados pendentes no percurso:</td>
                <td>
                  {this.props.estado_fluxo === 'CANCELADO' ? <Tooltip
                    title={'Justificação: ' + this.props.justificacao_qualificacao_anulada}
                    placement={"bottom-start"}><span><FontAwesomeIcon icon={faTimesCircle} color={"#bb0000"}/> Participação cancelada {this.props.qualificacao_anulada_por_nome ? `por ${this.props.qualificacao_anulada_por_nome}` : null} ({this.props.qualificacao_anulada_por_nin})</span></Tooltip> : this.props.estados_utilizador_percurso.map(estado => <span><FontAwesomeIcon icon={faCheck} color={"#1cacbf"}/> {estado.designacao}<br/></span>)}
                </td>
              </tr>
              {this.props.qualificacao_anulada_por && <tr>
                <td>Justificação:</td>
                <td>{this.props.justificacao_qualificacao_anulada}</td>
              </tr>}
            </>}
            {this.props.resultado !== 0 && <tr>
              <td>Resultado:</td>
              <td>{({
                "1": <span><FontAwesomeIcon icon={faCheckCircle} color={"#05cc1c"}/> Aprovado</span>,
                "-1": <span><FontAwesomeIcon icon={faTimesCircle} color={"#bf1b00"}/> Reprovado</span>,
                "-2": <span><FontAwesomeIcon icon={faTimesCircle} color={"#bf1b00"}/> Reprovado por falta de feedback</span>
              })[this.props.resultado]} ({(() => {
                if (this.props.data_falta)
                  return <span>faltou - {general.Renderers.dateRenderer(this.props.data_falta, {full: true})}</span>;
                if (this.props.data_avaliacao && this.props.resultado !== -2)
                  return <span>avaliado em {this.props.avaliacao} valores - {general.Renderers.dateRenderer(this.props.data_avaliacao, {full: true})}</span>;
                if (this.props.data_resultado)
                  return <span>{general.Renderers.dateRenderer(this.props.data_resultado, {full: true})}</span>;
              })()})
              </td>
            </tr>}
            {this.props.resultado !== 0 && this.props.justificacao_avaliacao && <tr>
              <td>Comentário de Avaliação:</td>
              <td>{this.props.justificacao_avaliacao}</td>
            </tr>}
          </table>
          {this.props.acoes_utilizador && this.props.acoes_utilizador.length > 0 && <div>
            <hr/>
            <div style={{textAlign: "center"}}>{this.props.acoes_utilizador.map((acao) => {
              let _acao = AcoesUtilizador[acao.action];
              if (!_acao)
                return null;
              return <span style={{margin: "0 5px"}}><Button size={'sm'} color={typeof _acao.color === 'function' ? _acao.color(this.props) : _acao.color} onClick={() => _acao.callback(classes, this.props, () => this.props.reloadData && this.props.reloadData())}>
                {typeof _acao.text === 'function' ? _acao.text(this.props) : _acao.text}
              </Button></span>;
            })}
            </div>
          </div>}
        </React.Fragment>}
      </div>}
    </SlideDown>;
  }
}

export default withStyles(styles)(UserDetailsBox);
